import { render, staticRenderFns } from "./GoogleModelViewer.vue?vue&type=template&id=0991ea66&scoped=true&"
import script from "./GoogleModelViewer.vue?vue&type=script&lang=ts&"
export * from "./GoogleModelViewer.vue?vue&type=script&lang=ts&"
import style0 from "./GoogleModelViewer.vue?vue&type=style&index=0&id=0991ea66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0991ea66",
  null
  
)

export default component.exports